<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="cop01">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contoursofdarkness_cop01.vue?1b53d2b1